const API_URL = 'https://server.ebusaka.com/v1/connect';
// const API_URL = 'http://127.0.0.1:3002/v1/connect';

exports.GET_MEDIA_TYPE_URL = (type, size) => `${API_URL}/media-room/${type}/${size}`;
exports.GET_PRE_SIGNED_URL = `${API_URL}/generate-pre-signed-url`;
exports.GET_MEDIA_URL = (id) => `${API_URL}/media/${id}`;
exports.SUBSCRIBE_URL = `${API_URL}/subscribe`;
exports.JOB_APPLY_URL = `${API_URL}/job-apply`;
exports.GET_MEDIA_PRIORITY_URL = `${API_URL}/media-priority`;
